import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { CampaignNegativeKeywordsTable } from '../components/campaigns/CampaignNegativeKeywordsTable'
import { TableStore } from '../components/table2/table_store'
import { useSavedFiltersStore } from '../hooks/useSavedFiltersStore'
import { useUser } from '../hooks/useUser'
import { useTableHooksFromStore } from '../packages/blueprint-components/src/useTableHooks'
import { userStore } from '../stores/user_store'
import { adManagerPerformanceGet } from '../util/adManagerPerformanceApi'

export const CampaignNegativeKeywords = observer(({}) => {
    const { profile } = useUser()
    const savedFiltersStore = useSavedFiltersStore()
    const [store] = useState(new TableStore<any>(userStore, 'campaign negative keywords'))

    const load = (params: any) => {
        if (!profile) {
            return Promise.resolve()
        }

        return adManagerPerformanceGet('api/v5/campaign-negative-keywords', params, true)
    }

    const tableHooks = useTableHooksFromStore(load, {}, false, store)

    return (
        <>
            <CampaignNegativeKeywordsTable
                tableHooks={tableHooks}
                store={store}
                savedFiltersStore={savedFiltersStore}
            />
        </>
    )
})
